/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const error = {
  required: 'This field is required',
  checkbox: 'This field must be checked',
  selectRequired: 'Select an option from list'
};
